._anchorsContainer_wq9on_1 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%; }
  ._anchorsContainer_wq9on_1._mobileEditor_wq9on_6, ._anchorsContainer_wq9on_1._mobileEditor_wq9on_6._fixed_wq9on_6 {
    width: 320px;
    left: calc((100% - 320px) / 2); }
